import React from 'react';
import { ChevronDown } from 'lucide-react';

// (2 Nov 2026, decision 170) The calendar name at the top of the dashboard and the
// member page, when it is also the drop-down for choosing a calendar. A drop-down
// cannot wrap its text, so a long name was cut short ("Hot Club de Cuisi…"). Here the
// name is ordinary text that wraps onto a second line, with the ⌄ kept after the last
// word, and the real drop-down lies invisibly over it: tapping the name opens the
// phone's own picker as before.
const CalendarNamePicker = ({
  name,
  value,
  onChange,
  children, // the <option>/<optgroup> elements
  textClass = 'text-xl text-gray-800', // size and colour of the name
  chevronClass = 'text-gray-500',
  className = '',
}) => {
  const words = String(name || '').trim().split(/\s+/);
  const last = words.pop() || '';
  const head = words.join(' ');
  return (
    <div className={`group relative rounded focus-within:ring-2 focus-within:ring-blue-400 ${className}`}>
      <span aria-hidden="true" className={`block font-bold leading-tight break-words group-hover:opacity-80 ${textClass}`}>
        {head && `${head} `}
        <span className="whitespace-nowrap">
          {last}
          <ChevronDown className={`inline-block w-4 h-4 ml-1 align-middle ${chevronClass}`} />
        </span>
      </span>
      <select
        aria-label={`Calendar: ${name || ''}. Choose another calendar`}
        value={value}
        onChange={onChange}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer appearance-none"
      >
        {children}
      </select>
    </div>
  );
};

export default CalendarNamePicker;
